<template>
  <v-container fluid class="pa-0 ma-0" style="margin-top: 0">
    <v-app id="inspire">
      <v-carousel
        cycle
        hide-delimiters
        :show-arrows="false"
        :height="carouselHeight"
        interval="5000"
      >
        <!-- Slide 1 -->
        <v-carousel-item>
          <v-card flat tile class="banner" :style="bannerStyle">
            <div class="overlay" :style="overlayStyle"></div>
            <div class="title">
              <h1 class="text-center gapspace12 zoom-fade">We Make IT Happen.</h1>
              <h3 class="text-center gapspace12 zoom-fade delay">
                A Beeline To Better Results
              </h3>
            </div>
          </v-card>
        </v-carousel-item>

        <!-- Slide 2 -->
        <v-carousel-item>
          <v-card flat tile class="banner" :style="bannerStyle2">
            <div class="title">
              <h1 class="text-center gapspace12 zoom-fade">We Make IT Happen.</h1>
              <h3 class="text-center gapspace12 zoom-fade delay">
                A Beeline To Better Results
              </h3>
            </div>
          </v-card>
        </v-carousel-item>
        <v-carousel-item>
          <v-card flat tile class="banner" :style="bannerStyle3">
            <div class="title">
              <h1 class="text-center gapspace12 zoom-fade">We Make IT Happen.</h1>
              <h3 class="text-center gapspace12 zoom-fade delay">
                A Beeline To Better Results
              </h3>
            </div>
          </v-card>
        </v-carousel-item>
      </v-carousel>

      <v-container fluid class="pa-0">
        <v-card class="black--text elevation-0" dark>
          <v-parallax
            src="@/assets/about-parrallax1.jpg"
            class="banner-img"
            :height="$vuetify.breakpoint.smAndDown ? 'auto' : '100%'"
          >
            <div ref="contentBlock" class="fill-height d-flex flex-column justify-center">
              <!-- Foreground Content -->
              <v-card class="black--text elevation-0 transparent" dark>
                <v-container>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-card class="elevation-0 transparent ma-2">
                        <div class="waviy mx-lg-8 text-center text-md-left">
                          <h1
                            class="rainbow-text font-weight-bold linespht fontfamMon"
                            style="font-size: clamp(20px, 4vw, 32px) !important"
                          >
                            Innovative Inspirational Invigorating
                          </h1>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>

              <!-- Bottom Content -->
              <v-container>
                <div class="mx-lg-8">
                  <v-row no-gutters>
                    <v-col cols="12" sm="7" xl="6">
                      <v-card class="ma-2 transparent">
                        <p class="mt-6 text-justify">
                          We promise that the projects that are designed and developed by
                          us will be the best with industry standards and will be built
                          using high-end technologies and delivered ahead of the committed
                          schedule.
                        </p>
                        <p class="mt-6 text-justify">
                          We, Buyuk Software Solutions is a growing IT Company with a
                          vision of achieving new innovative heights in the field of
                          Software Development. We are a team of experienced software
                          experts who are dedicated to deliver quality projects.
                        </p>
                        <v-btn class="clrblues" dark small rounded="pill">
                          About Us
                        </v-btn>
                      </v-card>
                    </v-col>

                    <v-col cols="12" sm="5" xl="6">
                      <v-card
                        class="pa-2 ma-2 d-flex align-center justify-center htlargef"
                        :height="$vuetify.breakpoint.smAndDown ? 'auto' : '100%'"
                      >
                        <v-img
                          src="@/assets/biometricvector11.png"
                          class="img-3d-float"
                          contain
                          max-width="100%"
                        />
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </div>
          </v-parallax>
        </v-card>
      </v-container>

      <v-container fluid class="pa-0">
        <div>
          <v-row no-gutters>
            <v-col cols="12">
              <v-img
                class="white--text htlargecertificatescn"
                src="@/assets/Certificates BG.png"
              >
                <v-container fluid class="px-4 bgpanel">
                  <v-card class="black--text elevation-0 bgpanel" dark>
                    <v-container>
                      <div>
                        <v-row no-gutters>
                          <v-col cols="12">
                            <v-card class="elevation-0">
                              <div class="waviy mx-lg-8 text-center mb-3">
                                <h1
                                  class="rainbow-text font-weight-bold linespht fontfamMon"
                                  style="font-size: clamp(22px, 4vw, 32px) !important"
                                >
                                  What We offer!!
                                </h1>
                              </div>
                              <p
                                class="linespht1 text-center d-block d-lg-none clrbluetext"
                              >
                                We have a dedicated team of experienced software experts
                                who can transform customer needs into quality software
                                products which are unique in themselves and cut down the
                                manual interventions and costs. Our focus is on developing
                                customized, client friendly software that automates
                                different areas of the business process.
                              </p>
                              <p
                                class="linespht1 text-center d-none d-lg-block clrbluetext"
                              >
                                We have a dedicated team of experienced software experts
                                who can transform customer needs into quality software
                                products which are unique in themselves and cut down the
                                manual interventions and costs. Our focus is on developing
                                customized, client friendly software that automates
                                different areas of the business process.
                              </p>
                            </v-card>
                          </v-col>
                        </v-row>
                      </div>
                    </v-container>
                  </v-card>
                </v-container>

                <v-container
                  class="services-block glass-effect py-0 my-0 my-md-2"
                  @mouseenter="stopAutoDisplay"
                  @mouseleave="startAutoDisplay"
                >
                  <div>
                    <v-row no-gutters justify="center">
                      <v-col cols="12" class="d-flex justify-center">
                        <v-card class="ma-2" elevation="2">
                          <!-- start slider -->

                          <v-container fluid class="py-0 px-0">
                            <v-row no-gutters class="d-flex align-stretch">
                              <!-- Left side: Tabs -->
                              <v-col cols="12" md="4" lg="3" class="d-none d-md-flex">
                                <div
                                  class="tabs-wrapper d-flex flex-column"
                                  style="height: 300px"
                                >
                                  <!-- top arrow -->
                                  <v-btn
                                    icon
                                    small
                                    class="scroll-btn top mb-2"
                                    :disabled="atTop"
                                    @click="scrollUp"
                                    :ripple="false"
                                  >
                                    <v-icon style="color: black">mdi-chevron-up</v-icon>
                                  </v-btn>

                                  <!-- scrollable tabs -->
                                  <div
                                    ref="tabsContainer"
                                    class="tabs-scroll flex-grow-1"
                                    @scroll="onScroll"
                                    style="
                                      max-height: 220px;
                                      overflow-y: auto;
                                      margin-top: 50px;
                                    "
                                  >
                                    <v-tabs
                                      v-model="tab"
                                      vertical
                                      background-color="white"
                                      class="rounded-xl"
                                    >
                                      <v-tab
                                        v-for="(item, i) in services"
                                        :key="i"
                                        :class="tab === i ? 'active-tab' : ''"
                                        :style="
                                          tab === i
                                            ? item.gradient
                                              ? {
                                                  backgroundImage: item.gradient,
                                                  color: '#fff',
                                                }
                                              : {
                                                  backgroundColor: item.color,
                                                  color: '#fff',
                                                }
                                            : {}
                                        "
                                        style="height: 55px"
                                      >
                                        <v-icon
                                          left
                                          :color="tab === i ? 'white' : 'primary'"
                                        >
                                          {{ item.icon }}
                                        </v-icon>
                                        {{ item.title }}
                                      </v-tab>
                                    </v-tabs>
                                  </div>

                                  <!-- bottom arrow -->
                                  <v-btn
                                    icon
                                    small
                                    class="scroll-btn bottom mt-2"
                                    :disabled="atBottom"
                                    @click="scrollDown"
                                    :ripple="false"
                                  >
                                    <v-icon style="color: black">mdi-chevron-down</v-icon>
                                  </v-btn>
                                </div>
                              </v-col>
                              <v-col cols="12" md="8" lg="9" class="d-flex">
                                <v-tabs-items
                                  v-model="tab"
                                  class="rounded-xl flex-grow-1 eager"
                                >
                                  <v-tab-item v-for="(item, i) in services" :key="i">
                                    <v-card
                                      flat
                                      class="py-13 px-8 rounded-xl fill-height"
                                      :style="
                                        tab === i
                                          ? item.gradient
                                            ? {
                                                backgroundImage: item.gradient,
                                                color: '#fff',
                                              }
                                            : {
                                                backgroundColor: item.color,
                                                color: '#fff',
                                              }
                                          : {}
                                      "
                                    >
                                      <v-row>
                                        <!-- Text Content -->
                                        <v-col
                                          cols="12"
                                          md="6"
                                          class="d-flex flex-column justify-center"
                                        >
                                          <h3
                                            class="font-weight-bold mb-4 animated-textbbn"
                                          >
                                            {{ item.title }}
                                          </h3>

                                          <p class="mb-4 text-justify animated-textbbn">
                                            {{ item.description }}
                                          </p>

                                          <v-list dense>
                                            <v-list-item
                                              v-for="(client, j) in item.clients"
                                              :key="j"
                                              class="px-0"
                                            >
                                              <v-list-item-content>
                                                <v-list-item-title>
                                                  <v-btn
                                                    :href="client.link"
                                                    target="_blank"
                                                    color="white"
                                                    class="text-none"
                                                    small
                                                    rounded="pill"
                                                  >
                                                    {{ client.name }}
                                                  </v-btn>
                                                </v-list-item-title>
                                              </v-list-item-content>
                                            </v-list-item>
                                          </v-list>
                                        </v-col>

                                        <v-col cols="12" md="6">
                                          <v-row dense justify="center">
                                            <v-col
                                              v-for="(img, k) in item.images"
                                              :key="k"
                                              cols="4"
                                              sm="3"
                                              md="5"
                                              xl="5"
                                              class="image-3d-wrapper d-flex justify-center"
                                            >
                                              <v-img
                                                :src="img"
                                                class="rounded-lg elevation-3 image-spin"
                                                height="100"
                                                width="100%"
                                                cover
                                              ></v-img>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                      </v-row>
                                    </v-card>
                                  </v-tab-item>
                                </v-tabs-items>
                              </v-col>
                            </v-row>
                          </v-container>

                          <!-- end slider -->
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-container>
              </v-img>
            </v-col>
          </v-row>
        </div>
      </v-container>

      <!-- end 4th section -->

      <!-- start 4th section -->
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 fontfamMon"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Our Popular Services
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="pa-0 mb-2">
        <div>
          <v-row no-gutters>
            <!-- Left side image -->
            <v-col cols="12" sm="6">
              <v-img class="white--text" height="630px" src="@/assets/aigroup.jpg" />
            </v-col>

            <!-- Right side with parallax -->
            <v-col cols="12" sm="6">
              <v-parallax class="pa-0" height="630" src="@/assets/newbgdd.jpg">
                <!-- start -->
                <v-container>
                  <div class="mt-4 mt-lg-16">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-card class="ma-2 pa-lg-6" elevation="6">
                          <h2 class="linespht">
                            We Have Created Professional Service For Our Customers.
                          </h2>

                          <p class="mt-6 text-justify linespht1">
                            BUYUK is comprised of highly passionate and experienced
                            individuals dedicated towards delivering products and services
                            of the highest quality. Our Program Managers, Programmers,
                            Creative Designers, and Quality Analyzers, have extensive
                            knowledge in developing mobile apps, web applications and
                            enterprise software.
                          </p>

                          <v-btn color="white" class="black--text" dark large>
                            Learn More
                            <v-icon class="ml-2"> mdi-arrow-top-right-thin </v-icon>
                          </v-btn>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-container>
                <!-- stop -->
              </v-parallax>
            </v-col>
          </v-row>
        </div>
      </v-container>

      <!-- end 4th section -->

      <!-- start 5th section -->
      <v-container fluid class="pa-0">
        <v-card class="black--text elevation-0" dark>
          <div
            v-if="$vuetify.breakpoint.smAndDown"
            class="banner-mobile"
            :style="bannerMobileStyle"
          >
            <div class="banner-overlay">
              <div ref="contentMobile">
                <!-- ======= YOUR CONTENT START ======= -->
                <v-container fluid class="px-4">
                  <v-card class="black--text elevation-0" dark>
                    <v-container>
                      <v-row no-gutters>
                        <v-col cols="12">
                          <v-card class="elevation-0">
                            <div class="waviy mx-lg-8">
                              <h1
                                class="rainbow-text fontfamMon font-weight-bold linespht display-1"
                                style="font-size: clamp(22px, 4vw, 32px) !important"
                              >
                                What we do ?
                              </h1>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-container>

                <v-container fluid class="pa-4">
                  <v-card class="black--text elevation-0" dark>
                    <v-container>
                      <v-row class="mrtopmobile" justify="center">
                        <v-col
                          v-for="(card, index) in Servicescards"
                          :key="index"
                          cols="12"
                          sm="6"
                          lg="4"
                          xl="4"
                          class="d-flex justify-center"
                        >
                          <div class="a-box">
                            <div class="img-container d-flex justify-center"></div>
                            <div
                              class="text-container d-flex flex-column justify-space-between align-center"
                              style="background-color: transparent !important"
                            >
                              <v-card class="text-center three-d-card">
                                <v-img
                                  :src="getImage(card.image)"
                                  class="brradius mx-auto"
                                  style="width: 50px; height: 50px"
                                />
                                <v-card-title
                                  class="pa-3 text-center d-flex justify-center"
                                >
                                  {{ card.title }}
                                </v-card-title>
                                <p class="body-1 text-center px-xl-16">
                                  {{ card.subtitle }}
                                </p>
                              </v-card>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-container>
                <!-- ======= YOUR CONTENT END ======= -->
              </div>
            </div>
          </div>

          <!-- Desktop: keep real parallax, but auto-fit height to content -->
          <v-parallax v-else :src="bgSrc" class="banner-desktop" :height="parallaxHeight">
            <div ref="contentDesktop" class="parallax-content">
              <!-- ======= SAME CONTENT AS ABOVE ======= -->
              <v-container fluid class="px-4">
                <v-card class="black--text elevation-0" dark>
                  <v-container>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-card class="elevation-0">
                          <div class="waviy mx-lg-8">
                            <h1
                              class="rainbow-text font-weight-bold linespht display-1"
                              style="font-size: clamp(24px, 5vw, 56px)"
                            >
                              What we do ?
                            </h1>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-container>

              <v-container fluid class="pa-4">
                <v-card class="black--text elevation-0" dark>
                  <v-container>
                    <v-row class="mrtopmobile" justify="center">
                      <v-col
                        v-for="(card, index) in Servicescards"
                        :key="index"
                        cols="12"
                        sm="6"
                        lg="4"
                        xl="4"
                        class="d-flex justify-center"
                      >
                        <div class="a-box">
                          <div class="img-container d-flex justify-center"></div>
                          <div
                            class="text-container d-flex flex-column justify-space-between align-center"
                            style="background-color: transparent !important"
                          >
                            <v-card class="text-center three-d-card">
                              <v-img
                                :src="getImage(card.image)"
                                class="brradius mx-auto"
                                style="width: 60px; height: 60px"
                              />
                              <v-card-title
                                class="pa-3 text-center d-flex justify-center"
                              >
                                {{ card.title }}
                              </v-card-title>
                              <p class="body-1 text-center px-xl-16">
                                {{ card.subtitle }}
                              </p>
                            </v-card>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-container>
              <!-- ======= CONTENT END ======= -->
            </div>
          </v-parallax>
        </v-card>
      </v-container>

      <!-- end 5th section -->

      <!-- start 3rd section -->
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text fontfamMon font-weight-bold linespht display-1"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Our Work Process
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="pa-4">
        <v-card class="black--text elevation-0" dark>
          <v-container fluid>
            <v-row class="text-center">
              <!-- Step 1 -->
              <v-col cols="12" sm="6" md="3">
                <div class="process-circle-wrap">
                  <span></span>
                  <div class="process-circle">
                    <div class="process-circle-icon">
                      <v-icon large color="black">mdi-pencil</v-icon>
                    </div>
                    <div class="process-circle-text">
                      <h3>Sketching</h3>
                    </div>
                    <div class="process-circle-num">01</div>
                  </div>
                </div>
              </v-col>

              <!-- Step 2 -->
              <v-col cols="12" sm="6" md="3">
                <div class="process-circle-wrap">
                  <span></span>
                  <div class="process-circle">
                    <div class="process-circle-icon">
                      <v-icon large color="black">mdi-tune</v-icon>
                    </div>
                    <div class="process-circle-text">
                      <h3>Designing</h3>
                    </div>
                    <div class="process-circle-num">02</div>
                  </div>
                </div>
              </v-col>

              <!-- Step 3 -->
              <v-col cols="12" sm="6" md="3">
                <div class="process-circle-wrap">
                  <span></span>
                  <div class="process-circle">
                    <div class="process-circle-icon">
                      <v-icon large color="black">mdi-cog</v-icon>
                    </div>
                    <div class="process-circle-text">
                      <h3>Reviewing</h3>
                    </div>
                    <div class="process-circle-num">03</div>
                  </div>
                </div>
              </v-col>

              <!-- Step 4 -->
              <v-col cols="12" sm="6" md="3">
                <div class="process-circle-wrap">
                  <span></span>
                  <div class="process-circle">
                    <div class="process-circle-icon">
                      <v-icon large color="black">mdi-send</v-icon>
                    </div>
                    <div class="process-circle-text">
                      <h3>Launching</h3>
                    </div>
                    <div class="process-circle-num">04</div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-container>

      <!-- start footer -->
      <WebsiteFooter />
      <!-- end footer -->
    </v-app>
  </v-container>
</template>

<script>
import WebsiteFooter from "../WebsitePages/WebsiteFooter.vue";
export default {
  components: {
    WebsiteFooter,
  },
  // start aug13
  computed: {
    bannerMobileStyle() {
      // Mobile: normal background that grows with content
      return {
        backgroundImage: `url(${this.bgSrc})`,
      };
    },
    // Responsive height fix
    carouselHeight() {
      if (this.$vuetify.breakpoint.xs) {
        return "100vh"; // phones
      } else if (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md) {
        return "100vh"; // tablets (iPad, iPad Pro)
      } else {
        return "650"; // large screens / desktops
      }
    },

    bannerStyle() {
      return {
        backgroundImage: `url(${require("@/assets/img2.jpg")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      };
    },
    overlayStyle() {
      return {
        backgroundImage: `url(${require("@/assets/after.png")})`,
        backgroundSize: "cover",
        backgroundPosition: "top",
      };
    },
    bannerStyle2() {
      return {
        backgroundImage: `url(${require("@/assets/imggif.gif")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      };
    },
    bannerStyle3() {
      return {
        backgroundImage: `url(${require("@/assets/imggif2.gif")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      };
    },
    overlayStyle2() {
      return {
        backgroundImage: `url(${require("@/assets/after.png")})`,
        backgroundSize: "cover",
        backgroundPosition: "top",
      };
    },
  },
  // end aug13
  data() {
    return {
      parallaxHeight: 650, // will be updated to fit content

      bgSrc: require("@/assets/bg-image1.jpg"),
      selected: 1,
      model: null,
      // start aug27
      tab: 0,
      atTop: true,
      atBottom: false,
      scrollStep: 80, // will be adjusted in mounted()
      autoInterval: null,
      services: [
        {
          title: "Sactin Interactive Panel",

          gradient: "linear-gradient(to right, #000046, #1cb5e0)",

          description:
            "It provides teachers with flexibility, reusability, and a variety of tools that make learning fun and intelligent. Similarly, for students, an interactive display in the classroom allow them to use technology productively , wisely and more effectively.",
          clients: [{ name: "View More", link: "#" }],
          images: [
            require("@/assets/BuyukInteractivePanel/panel1.jpg"),
            require("@/assets/BuyukInteractivePanel/panel2.jpg"),
            require("@/assets/BuyukInteractivePanel/panel3.jpg"),
          ],
        },
        {
          title: "Sactin GPS Tracking System",

          gradient: "linear-gradient(to right, #ee0979, #ff6a00)",
          description:
            "GPS tracking is the surveillance of location through use of the Global Positioning System (GPS ) to track the location of an entity or object remotely. The technology can pinpoint longitude, latitude, ground speed, and course direction of the target.",
          clients: [{ name: "View More", link: "#" }],
          images: [
            require("@/assets/BuyukGPStracking/gps1.jpg"),
            require("@/assets/BuyukGPStracking/gps2.jpg"),
            require("@/assets/BuyukGPStracking/gps3.jpg"),
          ],
        },
        {
          title: "Sactin Face Attentance System",

          gradient: " linear-gradient(to right, #8e0e00, #1f1c18)",
          description:
            "Sactin face attendance system works by verifying the person's face against the enrolled face to mark the person's daily attendance. All the individual need to do is stand in front of the camera and your face is verified instantly in milliseconds.",
          clients: [{ name: "View More", link: "#" }],
          images: [
            require("@/assets/BuyukAttentance/Attentance1.jpg"),
            require("@/assets/BuyukAttentance/Attentance2.jpg"),
            require("@/assets/BuyukAttentance/Attentance3.jpg"),
          ],
        },
        {
          title: "Sactin Real Time Tracking System",
          gradient: "linear-gradient(to right, #00bf8f, #001510)",
          description:
            "With so many people and things in motion, business and government leaders don't have time to manually track each movement. With location intelligence, they can create live maps and apps for monitoring.",
          clients: [{ name: "View More", link: "#" }],
          images: [
            require("@/assets/BuyukTracking/RealTimeTracking1.jpg"),
            require("@/assets/BuyukTracking/RealTimeTracking2.jpg"),
            require("@/assets/BuyukTracking/RealTimeTracking3.jpg"),
          ],
        },
        {
          title: "Sactin Library System",

          gradient: "linear-gradient(to right, #833ab4, #fd1d1d, #fcb045)",
          description:
            "Digital libraries are quickly becoming the norm at colleges and universities since they combine technology and information resources to allow remote access to educational content, breaking down the physical barriers.",
          clients: [{ name: "View More", link: "#" }],
          images: [
            require("@/assets/buyukLibrary/library1.jpg"),
            require("@/assets/buyukLibrary/library2.jpg"),
            require("@/assets/buyukLibrary/library3.jpg"),
          ],
        },
        {
          title: "Sactin ERP",

          gradient: "linear-gradient(to right, #52c234, #061700)",
          description:
            "The importance of an office administrator to an organization is substantial due to the duties that they are entrusted with; hence specialized training required , sactin ensure this with specialized ERP system.",
          clients: [{ name: "View More", link: "#" }],
          images: [
            require("@/assets/BuyukERP/ERP1.jpg"),
            require("@/assets/BuyukERP/ERP2.jpg"),
            require("@/assets/BuyukERP/ERP3.jpg"),
          ],
        },
        {
          title: "School Management System",

          gradient:
            " linear-gradient( 87.6deg,  rgba(241,16,48,1) 1.7%, rgba(242,171,33,1) 13.3%, rgba(226,242,33,1) 24.5%, rgba(12,207,22,1) 34.8%, rgba(75,205,200,1) 47.2%, rgba(8,39,211,1) 58.9%, rgba(150,101,229,1) 67.6%, rgba(80,6,198,1) 78.1%, rgba(246,98,248,1) 89.2%, rgba(248,98,181,1) 103.3%, rgba(228,129,144,1) 113.9% )",

          description:
            "Flawless Parent Teacher Communication. Improve your school image with our branded mobile app.",

          images: [
            require("@/assets/BuyukSchoolManagement/SMS1.jpg"),
            require("@/assets/BuyukSchoolManagement/SMS2.jpg"),
            require("@/assets/BuyukSchoolManagement/SMS3.jpg"),
          ],
        },
        {
          title: "Web Designing",
          gradient: "linear-gradient(to right, #000046, #1cb5e0)",

          description:
            "Whether you need to redesign your existing website or design one from scratch, we have got all the skills to make it happen for you.",

          images: [
            require("@/assets/BuyukWebdesign/webd1.jpg"),
            require("@/assets/BuyukWebdesign/webd2.jpg"),
            require("@/assets/BuyukWebdesign/webd3.jpg"),
          ],
        },
        {
          title: "Premium Support",

          gradient:
            "  linear-gradient(90deg, rgba(42, 0, 27, 1.000) 0.000%, rgba(120, 19, 12, 1.000) 16.667%, rgba(206, 72, 14, 1.000) 33.333%, rgba(255, 141, 34, 1.000) 50.000%, rgba(255, 213, 67, 1.000) 66.667%, rgba(255, 255, 105, 1.000) 83.333%, rgba(255, 255, 141, 1.000) 100.000%) ",
          description:
            "Our Beliefs and Strengths are - Teamwork. Commitment. Professional Delivery. Our vastly experienced team are ready to provide tailor-made solutions to match any type of customer requirement.",

          images: [
            require("@/assets/BuyukPremiumSupport/premiums1.jpg"),
            require("@/assets/BuyukPremiumSupport/premiums2.jpg"),
            require("@/assets/BuyukPremiumSupport/premiums3.jpg"),
          ],
        },
        {
          title: "Mobile App Development",

          gradient:
            "  conic-gradient(from 105deg, rgba(255, 191, 171, 1.000) 0.000deg, rgba(255, 191, 171, 1.000) 9.730deg, rgba(254, 173, 169, 1.000) 9.730deg, rgba(254, 173, 169, 1.000) 19.459deg, rgba(237, 156, 167, 1.000) 19.459deg, rgba(237, 156, 167, 1.000) 29.189deg, rgba(220, 138, 165, 1.000) 29.189deg, rgba(220, 138, 165, 1.000) 38.919deg, rgba(204, 122, 164, 1.000) 38.919deg, rgba(204, 122, 164, 1.000) 48.649deg, rgba(189, 105, 162, 1.000) 48.649deg, rgba(189, 105, 162, 1.000) 58.378deg, rgba(173, 90, 160, 1.000) 58.378deg, rgba(173, 90, 160, 1.000) 68.108deg, rgba(159, 76, 158, 1.000) 68.108deg, rgba(159, 76, 158, 1.000) 77.838deg, rgba(145, 64, 156, 1.000) 77.838deg, rgba(145, 64, 156, 1.000) 87.568deg, rgba(132, 53, 154, 1.000) 87.568deg, rgba(132, 53, 154, 1.000) 97.297deg, rgba(120, 44, 152, 1.000) 97.297deg, rgba(120, 44, 152, 1.000) 107.027deg, rgba(108, 37, 151, 1.000) 107.027deg, rgba(108, 37, 151, 1.000) 116.757deg, rgba(98, 32, 149, 1.000) 116.757deg, rgba(98, 32, 149, 1.000) 126.486deg, rgba(88, 29, 147, 1.000) 126.486deg, rgba(88, 29, 147, 1.000) 136.216deg, rgba(80, 28, 145, 1.000) 136.216deg, rgba(80, 28, 145, 1.000) 145.946deg, rgba(72, 30, 143, 1.000) 145.946deg, rgba(72, 30, 143, 1.000) 155.676deg, rgba(66, 34, 141, 1.000) 155.676deg, rgba(66, 34, 141, 1.000) 165.405deg, rgba(61, 39, 139, 1.000) 165.405deg, rgba(61, 39, 139, 1.000) 175.135deg, rgba(57, 47, 137, 1.000) 175.135deg, rgba(57, 47, 137, 1.000) 184.865deg, rgba(54, 57, 135, 1.000) 184.865deg, rgba(54, 57, 135, 1.000) 194.595deg, rgba(53, 69, 133, 1.000) 194.595deg, rgba(53, 69, 133, 1.000) 204.324deg, rgba(53, 82, 131, 1.000) 204.324deg, rgba(53, 82, 131, 1.000) 214.054deg, rgba(54, 97, 129, 1.000) 214.054deg, rgba(54, 97, 129, 1.000) 223.784deg, rgba(56, 112, 127, 1.000) 223.784deg, rgba(56, 112, 127, 1.000) 233.514deg, rgba(59, 129, 124, 1.000) 233.514deg, rgba(59, 129, 124, 1.000) 243.243deg, rgba(64, 146, 122, 1.000) 243.243deg, rgba(64, 146, 122, 1.000) 252.973deg, rgba(70, 164, 120, 1.000) 252.973deg, rgba(70, 164, 120, 1.000) 262.703deg, rgba(77, 181, 118, 1.000) 262.703deg, rgba(77, 181, 118, 1.000) 272.432deg, rgba(85, 198, 116, 1.000) 272.432deg, rgba(85, 198, 116, 1.000) 282.162deg, rgba(94, 215, 114, 1.000) 282.162deg, rgba(94, 215, 114, 1.000) 291.892deg, rgba(104, 231, 112, 1.000) 291.892deg, rgba(104, 231, 112, 1.000) 301.622deg, rgba(116, 246, 110, 1.000) 301.622deg, rgba(116, 246, 110, 1.000) 311.351deg, rgba(128, 255, 108, 1.000) 311.351deg, rgba(128, 255, 108, 1.000) 321.081deg, rgba(140, 255, 105, 1.000) 321.081deg, rgba(140, 255, 105, 1.000) 330.811deg, rgba(154, 255, 103, 1.000) 330.811deg, rgba(154, 255, 103, 1.000) 340.541deg, rgba(168, 255, 101, 1.000) 340.541deg, rgba(168, 255, 101, 1.000) 350.270deg, rgba(183, 255, 99, 1.000) 350.270deg 360.000deg)",
          description:
            "we are here with you to turn your innovative ideas into attractive mobile applications.",

          images: [
            require("@/assets/BuyukMobileApp/mapp1.jpg"),
            require("@/assets/BuyukMobileApp/mapp2.jpg"),
            require("@/assets/BuyukMobileApp/mapp3.jpg"),
          ],
        },
        {
          title: "Customised Software",

          gradient:
            "  conic-gradient(from 180deg, rgba(0, 0, 0, 1.000) 0.000deg, rgba(0, 0, 0, 1.000) 10.909deg, rgba(0, 0, 0, 1.000) 21.818deg, rgba(2, 0, 0, 1.000) 32.727deg, rgba(27, 0, 0, 1.000) 43.636deg, rgba(52, 0, 0, 1.000) 54.545deg, rgba(78, 0, 0, 1.000) 65.455deg, rgba(102, 0, 0, 1.000) 76.364deg, rgba(124, 7, 0, 1.000) 87.273deg, rgba(143, 29, 0, 1.000) 98.182deg, rgba(159, 52, 7, 1.000) 109.091deg, rgba(169, 75, 29, 1.000) 120.000deg, rgba(175, 97, 52, 1.000) 130.909deg, rgba(176, 117, 75, 1.000) 141.818deg, rgba(172, 135, 97, 1.000) 152.727deg, rgba(162, 150, 117, 1.000) 163.636deg, rgba(148, 161, 135, 1.000) 174.545deg, rgba(130, 168, 149, 1.000) 185.455deg, rgba(109, 170, 160, 1.000) 196.364deg, rgba(85, 169, 166, 1.000) 207.273deg, rgba(60, 162, 169, 1.000) 218.182deg, rgba(34, 152, 166, 1.000) 229.091deg, rgba(10, 138, 160, 1.000) 240.000deg, rgba(0, 121, 149, 1.000) 250.909deg, rgba(0, 101, 134, 1.000) 261.818deg, rgba(0, 79, 117, 1.000) 272.727deg, rgba(0, 56, 96, 1.000) 283.636deg, rgba(0, 33, 74, 1.000) 294.545deg, rgba(0, 11, 52, 1.000) 305.455deg, rgba(0, 0, 29, 1.000) 316.364deg, rgba(0, 0, 7, 1.000) 327.273deg, rgba(0, 0, 0, 1.000) 338.182deg, rgba(0, 0, 0, 1.000) 349.091deg, rgba(0, 0, 0, 1.000) 360.000deg)",
          description:
            "If you have any questions regarding outsourcing your software please don't hesitate to contact us. We have a dedicated team of technologists who can understand all your needs and transform them into wonderful software product.",

          images: [
            require("@/assets/BuyukCSoftware/cs1.jpg"),
            require("@/assets/BuyukCSoftware/cs2.jpg"),
            require("@/assets/BuyukCSoftware/cs3.jpg"),
          ],
        },
        {
          title: "Web App Development",

          gradient:
            " linear-gradient( 111.5deg,  rgba(249,230,1,1) 9.9%, rgba(249,144,1,1) 19.4%, rgba(255,22,22,1) 29.2%, rgba(255,22,133,1) 37.7%, rgba(255,22,197,1) 47.7%, rgba(232,22,255,1) 53.9%, rgba(162,22,255,1) 60%, rgba(80,22,255,1) 68.8%, rgba(22,104,255,1) 74.2%, rgba(22,168,255,1) 77.6%, rgba(22,255,220,1) 86.7%, rgba(22,255,179,1) 92.5%, rgba(22,255,109,1) 97.1%, rgba(92,255,22,1) 103.5% )",
          description:
            "With our experience in marketing mass consumer products, we help you to build your dream product at the lowest cost and quick market release.",

          images: [
            require("@/assets/BuyukWebApp/webapp1.jpg"),
            require("@/assets/BuyukWebApp/webapp2.jpg"),
            require("@/assets/BuyukWebApp/webapp3.jpg"),
          ],
        },
      ],
      //  end aug27

      Servicescards: [
        {
          title: "Interactive Solutions",
          image: "checked.png",
          subtitle:
            "In a world that is constantly changing to become better, marketers too need to constantly innovate to stay ahead of competition. One such innovation that could completely set you apart from your competitors are the use of interactive solutions. We provide interactive solutions in the form of online products, panels and more.",
        },
        {
          title: " Web App Development",
          image: "app.png",
          subtitle:
            "Your website is the online identity of your brand. Your website tells the world who you are, and your customer will judge your brand and its quality through your website.Our expert team of web developers and designers can help you create or revamp your brand’s online presence to create a strong connect with your customers.",
        },
        {
          title: " Mobile App Development",
          image: "check.png",
          subtitle:
            "We are one among the emerging website and mobile app development company. We help companies transform their business process through consultation, development and deployment of custom-based mobile applications for iPhone, iPad, Android and Windows devices.",
        },
      ],
    };
  },

  mounted() {
    const observer1 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer1.unobserve(entry.target); // run only once
          }
        });
      },
      { threshold: 0.2 } // trigger when 20% visible
    );

    document.querySelectorAll(".process-circle").forEach((el) => {
      observer1.observe(el);
    });
    this.startAutoDisplay();
    this.$nextTick(() => {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
      }, 100); // wait for Vuetify to try scrolling
    });
    // compute step based on first tab height if available
    this.$nextTick(() => {
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
      const container = this.$refs.tabsContainer;
      const firstTab = container && container.querySelector(".v-tab");
      if (firstTab) {
        this.scrollStep = Math.max(firstTab.offsetHeight, 60);
      } else {
        // fallback to proportional step
        this.scrollStep = Math.round(container.clientHeight * 0.6);
      }
      this.onScroll();
      // keep button state updated on resize
      window.addEventListener("resize", this.onScroll);
      this.$nextTick(this.updateParallaxHeight);
      window.addEventListener("resize", this.updateParallaxHeight, { passive: true });
      this.startAutoDisplay();
    });
  },
  beforeDestroy() {
    this.stopAutoDisplay();
  },
  beforeDestroy() {
    clearInterval(this.autoInterval);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onScroll);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateParallaxHeight);
  },
  watch: {
    // Recalculate if your cards list changes
    Servicescards: {
      handler() {
        this.$nextTick(this.updateParallaxHeight);
      },
      deep: true,
    },
  },
  methods: {
    startAutoDisplay() {
      this.stopAutoDisplay(); // prevent duplicate intervals
      this.autoInterval = setInterval(() => {
        this.tab = (this.tab + 1) % this.services.length;

        this.$nextTick(() => {
          const tabs = this.$refs.tabsContainer;
          const active = tabs?.querySelector(".v-tab.active-tab");
          if (active && tabs) {
            tabs.scrollTop = active.offsetTop - tabs.offsetTop;
          }
        });
      }, 4000);
    },

    stopAutoDisplay() {
      if (this.autoInterval) {
        clearInterval(this.autoInterval);
        this.autoInterval = null;
      }
    },

    scrollUp() {
      this.$refs.tabsContainer.scrollBy({ top: -60, behavior: "smooth" });
    },
    scrollDown() {
      this.$refs.tabsContainer.scrollBy({ top: 60, behavior: "smooth" });
    },
    onScroll() {
      const el = this.$refs.tabsContainer;
      this.atTop = el.scrollTop === 0;
      this.atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight;
    },
    onScroll() {
      const c = this.$refs.tabsContainer;
      if (!c) return;
      this.atTop = c.scrollTop <= 0;
      this.atBottom = Math.ceil(c.scrollTop + c.clientHeight) >= c.scrollHeight;
    },
    scrollUp() {
      const c = this.$refs.tabsContainer;
      if (!c) return;
      c.scrollBy({ top: -this.scrollStep, left: 0, behavior: "smooth" });
    },
    scrollDown() {
      const c = this.$refs.tabsContainer;
      if (!c) return;
      c.scrollBy({ top: this.scrollStep, left: 0, behavior: "smooth" });
    },

    updateHeight() {
      const el = this.$refs.contentBlock;
      if (el) {
        this.parallaxHeight = el.offsetHeight + 60; // +60px buffer
      }
    },
    getImage(imageName) {
      return require(`@/assets/${imageName}`);
    },
    updateParallaxHeight() {
      // Only matters on desktop (where v-parallax is used)
      if (this.$vuetify.breakpoint.smAndDown) return;
      const el = this.$refs.contentDesktop;
      if (!el) return;
      const h = el.offsetHeight;
      // Add a small buffer so the parallax image covers edge-to-edge
      if (h && h > 0) this.parallaxHeight = Math.ceil(h + 32);
    },
  },
};
</script>

<style scoped>
::v-deep .theme--light.v-icon {
  color: white;
}

::v-deep .theme--light.v-sheet {
  background-color: transparent;
  border-color: transparent;
  color: white;
}

::v-deep .theme--dark.v-sheet {
  background-color: transparent;
  border-color: transparent;
  color: black;
}

::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}

.linespht {
  line-height: 1.5;
  letter-spacing: 2px !important;
}

.linespht1 {
  line-height: 1.5;
  letter-spacing: 1px;
}

@media screen and (min-width: 1100px) and (max-width: 1300px) {
  .htlargef {
    height: 80% !important;
  }
}

@media screen and (min-width: 1301px) and (max-width: 1670px) {
  .htlargef {
    height: 70% !important;
  }
}

@media screen and (min-width: 1671px) {
  .htlargef {
    height: 50% !important;
  }
}

.clrblues {
  background-color: #e29803 !important;
  color: white;
}

@media screen and (min-width: 700px) {
  .fd20 {
    font-size: 20px;
  }

  .fd50 {
    font-size: 40px;
    line-height: 1.5;
    letter-spacing: 2px;
  }
}

/* start card */
.a-box {
  display: inline-block;
  width: 100% !important;

  text-align: center;
}

.img-container {
  height: 120px;
  width: 200px;
  overflow: hidden;
  border-radius: 0px 0px 20px 20px;
  display: inline-block;
}

.text-container {
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2); */
  padding: 10px;
  border-radius: 20px;
  background: #e5e5e5;
  margin: -120px 0px 0px 0px;
  line-height: 19px;
  font-size: 14px;
  /* height: 200px; */
  /* height: 260px; */
}

.text-container h3 {
  margin: 20px 0px 10px 0px;
  /* color: #04bcff; */
  font-size: 18px;
}

.brradius {
  border-radius: 12px !important;
}

/* start slider */
.v-slide-group__prev,
.v-slide-group__next {
  color: purple;
  /* Customize the arrow color */
}

/* end slider */

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}

.waviy .spans {
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }

  20% {
    transform: translateY(-20px);
  }
}

/* end a1 */

/* a2 */

.contentan {
  position: relative;
}

.contentan h2 {
  color: #fff;
  font-size: 4em;
  position: absolute;
  transform: translate(-50%, -50%);
}

.contentan h2:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 2px #04357e;
}

.contentan h2:nth-child(2) {
  color: #04357e;
  animation: animate 4s ease-in-out infinite;
}

@keyframes animate {
  0%,
  100% {
    clip-path: polygon(
      0% 45%,
      16% 44%,
      33% 50%,
      54% 60%,
      70% 61%,
      84% 59%,
      100% 52%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      15% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}

.letpx {
  left: 100px;
}

/* end a2 */
/* start aug13 */
.banner {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  animation: bgZoomIn 4s ease-in-out 1 forwards;
}

.overlay {
  position: absolute;
  inset: 0;
  transform: scale(2);
  animation: bgZoomOut 4s ease-in-out 1 forwards;
  pointer-events: none;
  z-index: 0;
}

.title {
  position: relative;
  z-index: 1;
}

/* Animations */
@keyframes bgZoomIn {
  from {
    transform: scale(1.2);
  }

  to {
    transform: scale(1);
  }
}

@keyframes bgZoomOut {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(2);
  }
}

.banner {
  position: relative;
  top: 0;
  margin: 0;
}

/* end aug13 */
.gapspace12 {
  line-height: 1.5;
  letter-spacing: 2px;
}

@keyframes zoomFadeLoop {
  0% {
    opacity: 0.7;
    transform: scale(0.95);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  100% {
    opacity: 0.7;
    transform: scale(0.95);
  }
}

.zoom-fade {
  animation: zoomFadeLoop 2.5s ease-in-out infinite;
}

.zoom-fade.delay {
  animation-delay: 1.25s;
  /* half of animation time for staggering */
}

@keyframes wave3D {
  0% {
    transform: perspective(600px) rotateX(0deg) rotateY(0deg);
    text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  }

  25% {
    transform: perspective(600px) rotateX(15deg) rotateY(10deg);
    text-shadow: -2px 3px 12px rgba(0, 0, 0, 0.6);
  }

  50% {
    transform: perspective(600px) rotateX(0deg) rotateY(0deg) scale(1.05);
    text-shadow: 0px 0px 18px rgba(226, 152, 3, 0.8);
  }

  75% {
    transform: perspective(600px) rotateX(-15deg) rotateY(-10deg);
    text-shadow: 2px -3px 12px rgba(0, 0, 0, 0.6);
  }

  100% {
    transform: perspective(600px) rotateX(0deg) rotateY(0deg);
    text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  }
}

.animate-wave3d {
  display: inline-block;
  animation: wave3D 4s ease-in-out infinite;
  transform-style: preserve-3d;
}

.banner-img {
  /* height: 100vh !important;  */
  object-fit: cover;
  /* Ensures image covers screen */
}

.banner-img {
  background: url("@/assets/about-parrallax1.jpg") center center / cover no-repeat fixed;
  animation: zoomPan 15s ease-in-out infinite alternate;
}

/* Zoom + pan animation */
@keyframes zoomPan {
  0% {
    transform: scale(1) translate(0, 0);
  }

  50% {
    transform: scale(1.1) translate(-10px, -10px);
  }

  100% {
    transform: scale(1.05) translate(10px, 10px);
  }
}

.img-3d-float {
  animation: float3d 6s ease-in-out infinite;
  transform-style: preserve-3d;
}

@keyframes float3d {
  0% {
    transform: perspective(800px) rotateY(0deg) rotateX(0deg) translateY(0);
  }

  50% {
    transform: perspective(800px) rotateY(10deg) rotateX(5deg) translateY(-10px);
  }

  100% {
    transform: perspective(800px) rotateY(0deg) rotateX(0deg) translateY(0);
  }
}

.rainbow-text {
  background: linear-gradient(
    90deg,
    red,
    orange,
    yellow,
    green,
    blue,
    indigo,
    violet,
    red
  );
  background-size: 400% 400%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: rainbow-move 8s linear infinite;
}

@keyframes rainbow-move {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

/* Mobile background block: content defines height */
.banner-mobile {
  position: relative;
  width: 100%;
  background-size: cover !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  /* Parallax on mobile is janky, so keep it normal */
  background-attachment: scroll;
}

/* Optional dark overlay for readability */
.banner-overlay {
  width: 100%;
  height: 100%;
  padding: 24px 0;
}

/* Desktop parallax content area to be measured */
.parallax-content {
  padding: 24px 0;
}

/* Ensure images never overflow cards on small screens */
.a-box .text-container .v-card {
  max-width: 520px;
  width: 100%;
}

/* If your row gets tight on small screens, reduce side padding */
@media (max-width: 600px) {
  .px-xl-16 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}

.banner-img {
  background-size: cover !important;
  background-position: center center !important;
}

.content-wrapper {
  padding-bottom: 24px;
  /* ensures bottom content never clips */
}

.three-d-card {
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  transform-style: preserve-3d;
  perspective: 1000px;
}

.three-d-card:hover {
  transform: rotateY(15deg) rotateX(10deg) scale(1.05);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
  /* background-color: white; */
  /* background-color: #f4b021 !important; */
  background-image: radial-gradient(
    circle 1008px at -0.5% 50.2%,
    rgba(255, 85, 0, 1) 0%,
    rgba(255, 246, 73, 1) 50.4%,
    rgba(0, 233, 50, 1) 100.2%
  );
  color: white;
  padding: 40px 20px;
  border-radius: 9;
}

/* start aug27 */
.services-block {
  background: #fafafa;
}

.v-tab {
  font-weight: 600;
  text-transform: none;
  transition: 0.3s;
}

.glass-effect {
  border-radius: 15px;
  padding: 90px 0px 80px 0px;
  color: #0a0606;
  background-color: #ffffff;
  box-shadow: 2px 8px 16px 4px rgba(0, 0, 0, 0.08);
}

.tabs-wrapper {
  position: relative;
  width: 100%;
  height: 400px;
  /* adjust height as needed */
  display: block;
}

/* the scroll area — native scrollbar visually hidden but still scrollable */
.tabs-scroll {
  height: 100%;
  overflow-y: auto;
  padding-top: 40px;
  /* gives space so top arrow doesn't overlap content */
  padding-bottom: 40px;
  /* same for bottom */
  -ms-overflow-style: none;
  /* IE/Edge */
  scrollbar-width: none;
  /* Firefox */
}

.tabs-scroll::-webkit-scrollbar {
  display: none;
  /* Chrome/Safari */
}

/* overlay arrows centered horizontally */
.scroll-btn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  min-width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  background: white;
}

/* small offset so arrows don't collide with the card border */
.scroll-btn.top {
  top: 6px;
}

.scroll-btn.bottom {
  bottom: -40px;
}

/* optional: slight fade overlays to hint that content continues */
.tabs-scroll::before,
.tabs-scroll::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 28px;
  pointer-events: none;
  z-index: 10;
}

.tabs-scroll::before {
  top: 40px;
}

.tabs-scroll::after {
  bottom: 40px;
}

/* disabled button appearance */
.v-btn[disabled] {
  opacity: 0.45;
  pointer-events: none;
}

.v-tabs:focus {
  outline: none !important;
}

/* end aug 27 */
.image-3d-wrapper {
  perspective: 1200px;
  padding: 12px;
  /* space between images */
}

.image-spin {
  animation: spinCircle 6s linear infinite;
  transform-style: preserve-3d;
  border-radius: 12px;
}

/* Circular rotation */
@keyframes spinCircle {
  0% {
    transform: rotateY(0deg) scale(1);
  }

  25% {
    transform: rotateY(90deg) scale(1.05);
  }

  50% {
    transform: rotateY(180deg) scale(1.1);
  }

  75% {
    transform: rotateY(270deg) scale(1.05);
  }

  100% {
    transform: rotateY(360deg) scale(1);
  }
}

.animated-textbbn {
  opacity: 0;
  transform: translateY(10px);
  animation: fadeInUp 1s ease forwards;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.process-circle-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 3px solid #e29803;
  /* Vuetify primary color */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.process-circle-icon {
  font-size: 30px;
  margin-bottom: 10px;
}

.process-circle-num {
  position: absolute;
  bottom: -15px;
  background: #e29803;
  color: #fff;
  border-radius: 50%;
  padding: 5px 12px;
  font-weight: bold;
}
.process-circle {
  position: relative;
  background: white;
  border-radius: 50%;
  padding: 30px;
  text-align: center;
  transition: all 0.4s ease; /* smooth animation */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg); /* zoom + tilt */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* stronger glow */
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 10px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg); /* spin icon */
}

.process-circle-text h3 {
  margin: 0;
  font-size: 18px;
  transition: color 0.3s ease;
}

.process-circle:hover .process-circle-text h3 {
  color: #e29803; /* change text color on hover */
}
.process-circle {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
}

.process-circle.visible {
  opacity: 1;
  transform: translateY(0);
}

.process-circle:nth-child(1) {
  transition-delay: 0.2s;
}
.process-circle:nth-child(2) {
  transition-delay: 0.4s;
}
.process-circle:nth-child(3) {
  transition-delay: 0.6s;
}
.process-circle:nth-child(4) {
  transition-delay: 0.8s;
}
.process-circle {
  width: 150px; /* fixed width */
  height: 150px; /* equal height */
  border-radius: 50%; /* make it a circle */
  background: white;
  display: flex;
  flex-direction: column; /* stack icon + text + number */
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto; /* center inside column */
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.4s ease;
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg);
}

.process-circle-num {
  position: absolute;
  bottom: -20px; /* place number outside circle */
  font-weight: bold;
  font-size: 18px;
  color: white;
}
@keyframes pulseLoop {
  0% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto;
  position: relative;
  cursor: pointer;

  /* 👇 add looping animation */
  animation: pulseLoop 3s ease-in-out infinite;
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle-num {
  position: absolute;
  bottom: -20px;
  font-weight: bold;
  font-size: 18px;
  color: white;
}
/* .fontfamMon {
  font-family: Montserrat !important;
} */
</style>
